import { ReactNode, useMemo } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { TInsuranceUpgradePlan } from '@/common/integrations/menhir/employee/insurance/insurance.types';
import { LanguageType } from '@/common/types/general';
import { INTL_MONTH_DAY_FORMAT, intlFormat } from '@/common/utils/date';
import { tArray } from '@/common/utils/i18n';
import { FAQs } from '@coverflex-tech/hypernova';

export const InsuranceUpgradePlanFAQs = ({
  title,
  faqsI18nKey,
  plan,
}: TInsuranceUpgradePlanFAQsProps) => {
  const { i18n } = useTranslation();

  const faqs = useMemo(() => {
    const fileUrl =
      plan?.files?.find((f) => f.slug === 'general_conditions')?.url || '#';
    const date = intlFormat(plan?.startDate, INTL_MONTH_DAY_FORMAT, {
      language: i18n.language as LanguageType,
    });
    const transProps = {
      components: {
        general_conditions: (
          <a href={fileUrl} target="_blank" rel="noreferrer">
            general conditions
          </a>
        ),
      },
      values: { date },
    };
    return tArray<{ question: string; answer: string }>(faqsI18nKey).map(
      (faq) => ({
        question: <Trans {...transProps}>{faq.question}</Trans>,
        answer: <Trans {...transProps}>{faq.answer}</Trans>,
      })
    );
  }, [plan?.files, plan?.startDate, i18n.language, faqsI18nKey]);

  return <FAQs title={title} faqs={faqs} />;
};

export type TInsuranceUpgradePlanFAQsProps = {
  title: ReactNode;
  faqsI18nKey: string;
  plan?: Pick<TInsuranceUpgradePlan, 'files' | 'startDate'>;
};
